import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { Button } from '@src/components/ui/button/button';
import { Form } from '@src/components/ui/react-hook-form/form/form';
import { SubmitButton } from '@src/components/ui/react-hook-form/submit-button/submit-button';
import { cn } from '@src/utils/ui';
import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@src/components/ui/react-hook-form/text-Input/text-input';
import toastr from 'toastr';
import { axios } from '@src/lib/axios';

export const ConfirmIdentityForm = ({ onSubmit, defaultValues, ...props }) => {
    const handleSubmit = async values => {
        try {
            if (defaultValues.firstName !== values.firstName || defaultValues.lastName !== values.lastName) {
                await axios.post('/users/update-tasker-name', values);
            }

            await onSubmit(values);
            props.onClose();
        } catch (err) {
            console.log('confirm identity error:', err);
            const errorMessage = err?.message || 'Please try again later.';
            toastr.error(errorMessage, 'Oops! Something went wrong.');
        }
    };

    return (
        <Dialog {...props} className='tw-px-[24px] tw-py-[16px]'>
            <Form className='tw-space-[12px]' onSubmit={handleSubmit} defaultValues={defaultValues}>
                <DialogContent>
                    <div className='tw-flex tw-flex-col tw-gap-[16px] tw-text-[16px] tw-text-bcaa-grey-900'>
                        <div>
                            <h6 className='tw-text-[20px] tw-font-medium'>Confirm Your Details</h6>
                            <p>
                                To proceed, please make sure your first name and last name exactly match your
                                government-issued ID. If something doesn't look right, you can update it here.
                            </p>
                        </div>
                        <div>
                            <b className='tw-font-medium'>First Name</b>
                            <TextInput name='firstName' variant='outlined' className='tw-w-full' />
                        </div>

                        <div>
                            <b className='tw-font-medium'>Last Name</b>
                            <TextInput name='lastName' variant='outlined' className='tw-w-full' />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className='tw-p-[8px] tw-flex tw-justify-end'>
                    <Button className={cn('tw-p-[8px] tw-text-[14px]')} variant='text' onClick={props.onClose}>
                        Close
                    </Button>
                    <SubmitButton className={cn('tw-p-[8px] tw-text-[14px]')} autoFocus variant='contained'>
                        Proceed
                    </SubmitButton>
                </DialogActions>
            </Form>
        </Dialog>
    );
};

ConfirmIdentityForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool,
    defaultValues: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired
    }).isRequired
};
